module.exports = __webpack_public_path__ + "img/kazaxstan.d080a0c0.jpg";